"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTimeStampWithUnits = exports.formatTimeStamp = exports.elapsedTimeInSections = exports.calculateToDate = exports.calculateFromToday = exports.sortByDate = exports.isUserPostWedding = exports.isPostWedding = exports.isSameDateUtc = exports.isSameDate = exports.formatCalendarFrom = exports.formatDateFrom = exports.formatDateIso = exports.formatDateUtcLocal = exports.formatDateUtc = exports.formatDateLocal = exports.formatDate = exports.addYears = exports.addMonths = exports.addDays = exports.getDaysInMonth = exports.getDateMillisecondsUtc = exports.getDateMilliseconds = exports.getDateUtc = exports.getDate = exports.parseDateUtc = exports.parseDate = exports.isAfterDate = exports.isBeforeDate = exports.isValidDate = void 0;

require("core-js/modules/es.math.trunc.js");

require("core-js/modules/es.array.concat.js");

var _dayjs = _interopRequireDefault(require("dayjs"));

var _calendar = _interopRequireDefault(require("dayjs/plugin/calendar"));

var _customParseFormat = _interopRequireDefault(require("dayjs/plugin/customParseFormat"));

var _relativeTime = _interopRequireDefault(require("dayjs/plugin/relativeTime"));

var _utc = _interopRequireDefault(require("dayjs/plugin/utc"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_dayjs.default.extend(_calendar.default);

_dayjs.default.extend(_customParseFormat.default);

_dayjs.default.extend(_relativeTime.default);

_dayjs.default.extend(_utc.default);

/**
 * Checks whether a date is valid
 *
 * @param date - The date to check
 * @returns True if the date is valid; false otherwise, such as "2021-03-00" (there is no March 0)
 */
var isValidDate = function isValidDate(date) {
  return Boolean(date && (0, _dayjs.default)(date).isValid());
};
/**
 * Checks whether a date is before another date
 *
 * @param date - The date to check
 * @param beforeDate - The date to compare
 * @returns True if the date is before the other date; false otherwise
 */


exports.isValidDate = isValidDate;

var isBeforeDate = function isBeforeDate(date, beforeDate) {
  return (0, _dayjs.default)(date).isBefore(beforeDate);
};
/**
 * Checks whether a date is after another date
 *
 * @param date - The date to check
 * @param afterDate - The date to compare
 * @returns True if the date is after the other date; false otherwise
 */


exports.isBeforeDate = isBeforeDate;

var isAfterDate = function isAfterDate(date, afterDate) {
  return (0, _dayjs.default)(date).isAfter(afterDate);
};
/**
 * Parses the specified date based on a format string, represented as local time
 *
 * @param date - The date string to parse
 * @param format - An optional tokenized format string
 * @param strict - Strict parsing requires the date string to exactly match the format string, including delimiters
 * @returns A new date as local time
 */


exports.isAfterDate = isAfterDate;

var parseDate = function parseDate(date, format) {
  var strict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return (0, _dayjs.default)(date, format, strict).toDate();
};
/**
 * Parses the specified date based on a format string, represented as UTC
 *
 * @param date - The date string to parse
 * @param format - An optional tokenized format string
 * @returns A new date as UTC
 */


exports.parseDate = parseDate;

var parseDateUtc = function parseDateUtc(date, format) {
  return _dayjs.default.utc(date, format).toDate();
};
/**
 * Gets the current or specified date, represented as local time
 *
 * @param date - An optional date to convert to local time
 * @returns A new date as local time
 */


exports.parseDateUtc = parseDateUtc;

var getDate = function getDate(date) {
  return (0, _dayjs.default)(date).toDate();
};
/**
 * Gets the current or specified date, represented as UTC
 *
 * @param date - An optional date to convert to UTC
 * @returns A new date as UTC
 */


exports.getDate = getDate;

var getDateUtc = function getDateUtc(date) {
  return _dayjs.default.utc(date).toDate();
};
/**
 * Gets the number of milliseconds since the Unix Epoch
 *
 * @param date - The date to get the value of
 * @returns The number of milliseconds since the Unix Epoch
 */


exports.getDateUtc = getDateUtc;

var getDateMilliseconds = function getDateMilliseconds(date) {
  return (0, _dayjs.default)(date).valueOf();
};
/**
 * Gets the number of milliseconds since the Unix Epoch
 *
 * @param date - The date to get the value of
 * @returns The number of milliseconds since the Unix Epoch
 */


exports.getDateMilliseconds = getDateMilliseconds;

var getDateMillisecondsUtc = function getDateMillisecondsUtc(date) {
  return _dayjs.default.utc(date).valueOf();
};
/**
 * Gets the number of days in the specified month
 *
 * @param date - The month date
 * @returns The number of days in the month
 */


exports.getDateMillisecondsUtc = getDateMillisecondsUtc;

var getDaysInMonth = function getDaysInMonth(date) {
  return (0, _dayjs.default)(date).daysInMonth();
};
/**
 * Adds the specified number of days to a date
 *
 * @param date - The date to add days to
 * @param days - The number of days to add, which can also be negative
 * @returns A new date
 */


exports.getDaysInMonth = getDaysInMonth;

var addDays = function addDays(date, days) {
  return (0, _dayjs.default)(date).add(days, 'days').toDate();
};
/**
 * Adds the specified number of months to a date
 *
 * @param date - The date to add months to
 * @param months - The number of months to add, which can also be negative
 * @returns A new date
 */


exports.addDays = addDays;

var addMonths = function addMonths(date, months) {
  return (0, _dayjs.default)(date).add(months, 'months').toDate();
};
/**
 * Adds the specified number of years to a date
 *
 * @param date - The date to add years to
 * @param years - The number of years to add, which can also be negative
 * @returns A new date
 */


exports.addMonths = addMonths;

var addYears = function addYears(date, years) {
  return (0, _dayjs.default)(date).add(years, 'years').toDate();
};
/**
 * Formats a date based on a tokenzied string, represented as local time
 *
 * @param date - The date to format
 * @param format - A tokenized format string
 * @returns A string in the specified format, such as "M/D/YYYY"
 */


exports.addYears = addYears;

var formatDate = function formatDate(date, format) {
  return (0, _dayjs.default)(date).format(format);
};
/**
 * Formats a date based on a tokenzied string, represented as local time
 *
 * @param date - The date to format
 * @param format - A tokenized format string
 * @returns A string in the specified format, such as "M/D/YYYY"
 */


exports.formatDate = formatDate;

var formatDateLocal = function formatDateLocal(date, format) {
  return (0, _dayjs.default)(date).local().format(format);
};
/**
 * Formats a date based on a tokenized string, represented as UTC
 *
 * @param date - The date to format
 * @param format - A tokenized format string
 * @returns A string in the specified format, such as "M/D/YYYY"
 */


exports.formatDateLocal = formatDateLocal;

var formatDateUtc = function formatDateUtc(date, format) {
  return _dayjs.default.utc(date).format(format);
};
/**
 * Formats a date based on a tokenized string, represented as UTC
 *
 * @param date - The date to format
 * @param format - A tokenized format string
 * @returns A string in the specified format, such as "M/D/YYYY"
 */


exports.formatDateUtc = formatDateUtc;

var formatDateUtcLocal = function formatDateUtcLocal(date, format) {
  return _dayjs.default.utc(date).local().format(format);
};
/**
 * Formats a date as a simplified extended ISO string
 *
 * @param date - The date to format
 * @returns A string in simplified extended ISO format, such as "2021-03-20T00:00:00.000Z"
 */


exports.formatDateUtcLocal = formatDateUtcLocal;

var formatDateIso = function formatDateIso(date) {
  return (0, _dayjs.default)(date).toISOString();
};
/**
 * Formats a date as a string representing the time in relation to another date
 *
 * @param date - The date to format
 * @param fromDate - The date to use as a reference
 * @returns A string representing a relative time, such as "a day ago" or "in 6 months"
 */


exports.formatDateIso = formatDateIso;

var formatDateFrom = function formatDateFrom(date, fromDate) {
  return (0, _dayjs.default)(date).from(fromDate);
};
/**
 * Formats a date in a less granular way than formatDateFrom
 *
 * @param date - The date to format
 * @returns A string representing a relative time, such as "today" or "last week"
 */


exports.formatDateFrom = formatDateFrom;

var formatCalendarFrom = function formatCalendarFrom(date) {
  return (0, _dayjs.default)(date).calendar(new Date(), {
    sameDay: '[Today]',
    // The same day ( Today at 2:30 AM )
    nextDay: '[Tomorrow]',
    // The next day ( Tomorrow at 2:30 AM )
    nextWeek: 'dddd',
    // The next week ( Sunday at 2:30 AM )
    lastDay: '[Yesterday]',
    // The day before ( Yesterday at 2:30 AM )
    lastWeek: '[Last] dddd',
    // Last week ( Last Monday at 2:30 AM )
    sameElse: 'M/D/YYYY' // Everything else ( 7/10/2011 )

  });
};
/**
 * Determines if two dates are the same. If the dates are in UTC, use isSameDateUtc instead.
 *
 * @returns boolean
 */


exports.formatCalendarFrom = formatCalendarFrom;

var isSameDate = function isSameDate(date1, date2) {
  return (0, _dayjs.default)(date1).isSame((0, _dayjs.default)(date2), 'day');
};
/**
 * Determines if two dates are the same, where each date is in UTC
 *
 * @returns boolean
 */


exports.isSameDate = isSameDate;

var isSameDateUtc = function isSameDateUtc(date1, date2) {
  return _dayjs.default.utc(date1).isSame(_dayjs.default.utc(date2), 'day');
};
/**
 * Returns whether the specified wedding date has passed
 * @param weddingDate
 * @returns boolean. true, if wedding date is before today's date; false if wedding date is today or future day
 */


exports.isSameDateUtc = isSameDateUtc;

var isPostWedding = function isPostWedding(weddingDate) {
  return (0, _dayjs.default)().isAfter((0, _dayjs.default)(weddingDate), 'day');
};
/**
 * Returns whether the user's wedding date has passed
 * @param userContext
 * @returns boolean. true, if user's wedding date is before today's date; false if today or future day
 */


exports.isPostWedding = isPostWedding;

var isUserPostWedding = function isUserPostWedding(userContext) {
  var _userContext$user_rol;

  var weddingDate = userContext === null || userContext === void 0 ? void 0 : (_userContext$user_rol = userContext.user_role_account_weddings) === null || _userContext$user_rol === void 0 ? void 0 : _userContext$user_rol[0].wedding_date;
  return !!(weddingDate && isPostWedding(weddingDate));
};
/**
 * Array.protoype.sort callback function to sort dates in descending order
 *
 * @example dates.sort(sortByDate);
 *
 * @param date1
 * @param date2
 * @returns number
 */


exports.isUserPostWedding = isUserPostWedding;

var sortByDate = function sortByDate(date1, date2) {
  if (isBeforeDate(date1, date2)) return -1;
  if (isAfterDate(date1, date2)) return 1;
  return 0;
};
/**
 * Detemines the length between a specific time and right now
 * @param date - The date associated with some element
 * @param afterDate - The date right now
 * @param unit - the type of units to measure by, defaults to 'seconds'
 * @returns A number of seconds that have elapsed between the two times
 */


exports.sortByDate = sortByDate;

var calculateFromToday = function calculateFromToday(date, afterDate) {
  var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'seconds';
  return (0, _dayjs.default)(afterDate).diff((0, _dayjs.default)(date), unit);
};
/**
 * Detemines the length between a specific time and right now
 * Opposite of `calculateFromToday`
 * @param date - The date right now
 * @param futureDate - The date associated with some element
 * @param unit - the type of units to measure by, defaults to 'seconds'
 * @returns A number of seconds that have elapsed between the two times
 */


exports.calculateFromToday = calculateFromToday;

var calculateToDate = function calculateToDate(date, futureDate) {
  var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'seconds';
  return (0, _dayjs.default)(futureDate).diff((0, _dayjs.default)(date), unit);
};
/**
 * Detemines the length between a specific time and right now
 * @param date - The date associated with some element
 * @param afterDate - The date right now
 * @param unit - the type of units to measure by, defaults to 'seconds'
 * @returns A number of seconds that have elapsed between the two times
 */


exports.calculateToDate = calculateToDate;
var elapsedTimeInSections = calculateFromToday;
/**
 * Formats a given time into a timestamp with a unit of times
 *
 * @param elapsedTime - the time that has passed in seconds
 * @param unit - unit so we know how to parse the seconds
 * @returns a formatted timestamp
 */

exports.elapsedTimeInSections = elapsedTimeInSections;

var formatTimeStamp = function formatTimeStamp(elapsedTime, unit) {
  var conversion;

  switch (unit) {
    case 'min':
      conversion = Math.trunc(elapsedTime / 60);
      break;

    case 'hour':
      conversion = Math.trunc(elapsedTime / 3600);
      break;

    case 'day':
      conversion = Math.trunc(elapsedTime / 86400);
      break;

    case 'week':
      conversion = Math.trunc(elapsedTime / 518401);
      break;

    default:
      throw Error("Unit ".concat(unit, " is not an acceptable time unit."));
  } // if the converted int is greater than 1, units are plural


  if (conversion === 1) {
    return "".concat(conversion, " ").concat(unit, " ago");
  }

  return "".concat(conversion, " ").concat(unit, "s ago");
};
/**
 * Returns formatted timestamp with correct units of time
 *
 * @param timestamp - timestamp in seconds
 * @returns a formatted timestamp string
 */


exports.formatTimeStamp = formatTimeStamp;

var setTimeStampWithUnits = function setTimeStampWithUnits(timeStamp) {
  if (!timeStamp) {
    return '';
  }

  var date = new Date(timeStamp * 1000);
  var today = getDate(new Date());
  var timeDiff = elapsedTimeInSections(date, today);

  if (timeDiff < 3) {
    // Less than 3 seconds ago
    return 'Just now';
  }

  if (timeDiff < 59) {
    // Less than 59 seconds ago
    return "".concat(timeDiff, " secs ago");
  }

  if (timeDiff <= 3540) {
    // between 1 min and 59 mins
    return formatTimeStamp(timeDiff, 'min');
  }

  if (timeDiff <= 82800) {
    // between 1 and 23 hours
    return formatTimeStamp(timeDiff, 'hour');
  }

  if (timeDiff <= 172800) {
    // yesterday
    return 'yesterday';
  }

  if (timeDiff <= 518400) {
    // between 2 and 6 days
    return formatTimeStamp(timeDiff, 'day');
  }

  if (timeDiff <= 2419200) {
    // between 7 days and 4 weeks
    return formatTimeStamp(timeDiff, 'week');
  } // longer than 4 weeks


  return formatDate(date, 'MMMM D, YYYY');
};

exports.setTimeStampWithUnits = setTimeStampWithUnits;